export default __webpack_public_path__ + "static/media/purple_flag.1a991407.svg";